import ProposalService from '../../services/ProposalService';
import { extractApiErrorMessage, openNotification } from '../../utils';

const PDF_MISSING_MESSAGE = 'Mevcut teklif PDF’i bulunamadı. Lütfen teklifi göndermeden önce PDF oluşturunuz.';

export const sendProposalWithExistingPdf = async (
  proposalId: number,
  invoiceEmailSendAt: string | null
) => {
  try {
    const latestArchiveResponse = await ProposalService.getLatestPdfArchive(proposalId);
    const latestPdfUrl = latestArchiveResponse?.data?.pdfUrl;

    if (!latestPdfUrl) {
      openNotification('warning', 'Uyarı', PDF_MISSING_MESSAGE);
      return false;
    }
  } catch (error) {
    const message = extractApiErrorMessage(error, PDF_MISSING_MESSAGE);
    openNotification('warning', 'Uyarı', message);
    return false;
  }

  try {
    await ProposalService.update(proposalId, {
      statusId: 3,
      invoiceEmailSendAt,
    });
    openNotification('success', 'Başarılı', 'Teklif Gönderildi.');
    return true;
  } catch (error) {
    const message = extractApiErrorMessage(error, 'Teklif gönderilirken hata oluştu.');
    openNotification('error', 'Hata', message);
    return false;
  }
};
